/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";
// core components

function IndexHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });
  const isDesktop = window.innerWidth >= 700 ? true : false

  return (
    <>
      <div className="page-header " >
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/header.jpg") + ")"
          }}
          ref={pageHeader}
        ></div>
        <Container>{
          isDesktop? <div className="content-rigth">
          <img
          style={{width:"300px"}}
            alt="..."
            className="n-logo"
            src={require("assets/img/logosinfondo.png")}
          ></img>
        </div>:
        <div className="content-center">
        <img
        style={{width:"300px"}}
          alt="..."
          className="n-logo"
          src={require("assets/img/logosinfondo.png")}
        ></img>
      </div>}
         

        </Container>
      </div>
    </>
  );
}

export default IndexHeader;